<template>
  <div>
    <p>
      Are you sure you want to delete <strong>{{ project.name }}</strong>?
    </p>
    <small>
      If you're sure, type <strong>{{ project.name }}</strong> into the text input below.
    </small>
    <input
        v-model="confirmDelete"
        class="input mt-15"
        type="text"
        :placeholder="project.name"
    >
    <button
      v-if="confirmDelete == project.name"
      class="button is-danger mt-15"
      @click="deleteProject"
    >
      Delete Project
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DeleteProject',
  props: {
    project: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDelete: '',
    };
  },
  computed: {
    ...mapState({
      user: state => state.profile.user,
      jwt: state => state.profile.jwt,
    }),
    API() {
      return this.$API;
    },
  },
  methods: {
    deleteProject() {
      const method = 'DELETE';
      const url = `${this.API}/projects/${this.project.id}`;
      this.axios({
        method,
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        url,
      })
        .then((response) => {
          if (response.status === 200) {
            location.reload(true);
          }
        })
        .catch(err => console.log(err));
    },
  },
};
</script>
<style lang="scss" scoped>
form {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 700px;
}
label {
  text-align: left;
}
select {
  background-image: none;
}
</style>
